import { useSelector } from "react-redux";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { useAnonymousTokenNetworkHeaders } from "./useAnonymousTokenNetworkHeaders";
import identity from "../../../selectors/identity";

export function useAnonymousOrNormalNetworkHeaders() {
  const anonymousNetworkHeaders = useAnonymousTokenNetworkHeaders();
  const networkHeaders = useNetworkHeaders();
  const isLoggedIn = useSelector(identity.isLoggedIn);
  return isLoggedIn ? networkHeaders : anonymousNetworkHeaders;
}
